import LeftChevronIcon from '@/CustomIcons/LeftChevron'
import { cn } from '@/utlis/cn'
import { motion } from 'framer-motion'
import { Collapsible as RadCollapsible } from 'radix-ui'
import { useState } from 'react'
import './collapsible.css'

type CollapsibleProps = {
    title?: React.ReactNode
    open?: boolean
    defaultOpen?: boolean
    children?: React.ReactNode
    onOpenChange?: (open: boolean) => void
    reverseOpenIndicator?: boolean
    className?: string
    triggerClassName?: string
}

export function Collapsible(props: CollapsibleProps) {
    const [isOpen, setOpen] = useState(props.open ?? props.defaultOpen ?? true)
    const reverseOpenIndicator = props.reverseOpenIndicator ? -1 : 1

    return (
        <RadCollapsible.Root
            open={props.open}
            className={props.className}
            onOpenChange={(open) => {
                setOpen(open)
                props.onOpenChange?.(open)
            }}
        >
            {props.title && (
                <RadCollapsible.Trigger
                    className={cn(
                        'w-full flex justify-between font-normal cursor-pointer items-center',
                        props.triggerClassName
                    )}
                >
                    {props.title}
                    <motion.div animate={{ rotateZ: (isOpen ? 90 : -90) * reverseOpenIndicator }}>
                        <LeftChevronIcon className="opacity-65" style={{ fontSize: '1.3rem' }} />
                    </motion.div>
                </RadCollapsible.Trigger>
            )}
            <RadCollapsible.Content className="collapsible-content">{props.children}</RadCollapsible.Content>
        </RadCollapsible.Root>
    )
}
